import { useMutation, useQuery, useQueryClient } from 'react-query';
import { addBrand, addFile, deleteBrand, deleteBrandWithItem, editBrand, fetchBrands, fetchBrands2, fetchFile, fetchFileForm } from '../api';
import { KEY_ENDPOINTS } from '../utils/keyapi-endpoints';
import { useMemo, useRef } from 'react';
import { debounce } from 'lodash';
//import { fetchBrands } from '../api/brand';

export const useGetFileForm = (suffixUrl: string, key: string, data: any = "", isAutoRefresh: boolean = true) => {
  return useQuery(
    key,
    () => fetchFileForm(suffixUrl, data),
    {
      enabled: isAutoRefresh,
      //refetchInterval:5000,
      //refetchOnmount:true,
      //   onSuccess: (res) => {
      //      //setGetResult(res);
      //     return res.data

      //   },
      //   onError: (err) => {

      //     // setGetResult(fortmatResponse(err.response?.data || err));
      //   },
    }
  );
};

export const useGetFile = (suffixUrl: string, key: string, param: string = "", isAutoRefresh: boolean = true) => {
  return useQuery(
    key,
    () => fetchFile(suffixUrl, param),
    {
      enabled: isAutoRefresh,
      //refetchInterval:5000,
      //refetchOnmount:true,
      //   onSuccess: (res) => {
      //      //setGetResult(res);
      //     return res.data

      //   },
      //   onError: (err) => {

      //     // setGetResult(fortmatResponse(err.response?.data || err));
      //   },
    }
  );
};

export const useAddFile = (suffixUrl: string, key: string) => {
  const queryClient = useQueryClient()

  return useMutation((item) =>
    addFile(suffixUrl, item),
    key != "" ?
      {


        // When mutate is called:
        onMutate: async newItem => {
          // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
          await queryClient.cancelQueries(key)

          // Snapshot the previous value
          const previousTodos = queryClient.getQueryData(key)

          // Optimistically update to the new value
          queryClient.setQueryData(key, (old: any) => [...old, newItem])

          // Return a context object with the snapshotted value
          return { previousTodos }
        },
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: (err, newItem, context: any) => {
          queryClient.setQueryData(key, context.previousTodos)
        },
        // Always refetch after error or success:
        onSettled: () => {
          return queryClient.invalidateQueries(key)
        },
      } : {
        onMutate: async newItem => {

          return await queryClient.invalidateQueries()

        },
        onSettled: () => {
          return queryClient.invalidateQueries()
        },
      }
  );
};

export const useGetQuery = (suffixUrl: string, key: string, param: string = "", isAutoRefresh: boolean = true) => {  
  return useQuery(
    key,
    () => fetchBrands(suffixUrl, param),
    {
      enabled: isAutoRefresh,
      //refetchOnWindowFocus:true,
      //refetchInterval:-1,
      //refetchOnmount:true,
      //   onSuccess: (res) => {
      //      //setGetResult(res);
      //     return res.data

      //   },
      //   onError: (err) => {

      //     // setGetResult(fortmatResponse(err.response?.data || err));
      //   },
    }
  );
};

export const useGetQuery2 = (suffixUrl: string, key: string, param: string = "", isAutoRefresh: boolean = true) => {  
  return useQuery(
    key,
    () => fetchBrands2(suffixUrl, param),
    {
      enabled: isAutoRefresh,
      //refetchOnWindowFocus:true,
      //refetchInterval:-1,
      //refetchOnmount:true,
        onSuccess: (res) => {
           //setGetResult(res);
          return res.data

        },
        onError: (err) => {
          //return err.response?.data

          // setGetResult(fortmatResponse(err.response?.data || err));
        },
    }
  );
};

export const useAddQuery2 = (suffixUrl: string, key: string) => {
  return useMutation((item) =>
    addBrand(suffixUrl, item),    
  );
};


// export const useAddQuery2 = (suffixUrl: string, key: string) => {
//   const mutation = useMutation((item) => addBrand(suffixUrl, item));
//   const pendingRef = useRef<any>(null);

//   const guardedMutateAsync = async (item:any) => {
//     if (pendingRef.current) return pendingRef.current; // یک call در حال اجرا -> همون رو برگردون
//     const promise = mutation.mutateAsync(item).finally(() => {
//       pendingRef.current = null;
//     });
//     pendingRef.current = promise;
//     return promise;
//   };

//   return { ...mutation, mutateAsync: guardedMutateAsync };
// };

export const useAddQuery = (suffixUrl: string, key: string) => {
  const queryClient = useQueryClient()

  return useMutation((item) =>
    addBrand(suffixUrl, item),
    key != "" ?
      {


        // When mutate is called:
        onMutate: async newItem => {
          // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
          await queryClient?.cancelQueries(key)

          // Snapshot the previous value
          const previousTodos = queryClient?.getQueryData(key)

          // Optimistically update to the new value
          previousTodos && queryClient?.setQueryData(key, (old: any) => [...old, newItem])

          // Return a context object with the snapshotted value
          return { previousTodos }
        },
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: (err, newItem, context: any) => {
          queryClient?.setQueryData(key, context?.previousTodos)
        },
        // Always refetch after error or success:
        onSettled: () => {
          return queryClient?.invalidateQueries(key)
        },
      } : {
        onMutate: async newItem => {

          return await queryClient?.invalidateQueries()

        },
        onSettled: () => {
          return queryClient?.invalidateQueries()
        },
      }
  );
};

export const useEditQuery = (suffixUrl: string, key: string) => {
  const queryClient = useQueryClient()
  return useMutation((item: any) =>
    editBrand(suffixUrl, item, item.id),
    key != "" ?
      {

        // When mutate is called:
        onMutate: async newItem => {
          // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
          await queryClient.cancelQueries(key)

          // Snapshot the previous value
          const previousTodos = queryClient.getQueryData(key)

          // Optimistically update to the new value
          queryClient.setQueryData(key, (old: any) => [...old, newItem])

          // Return a context object with the snapshotted value
          return { previousTodos }
        },
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: (err, newItem, context: any) => {
          queryClient.setQueryData(key, context.previousTodos)
        },
        // Always refetch after error or success:
        onSettled: () => {
          queryClient.invalidateQueries(key)
        },
      }
      : {
        onMutate: async newItem => {

          return queryClient.invalidateQueries()

        },
        onSettled: () => {
          return queryClient.invalidateQueries()
        },
      }
  );
};

export const useEditQuery2 = (suffixUrl: string, key: string) => {
  const queryClient = useQueryClient()
  return useMutation((item: any) =>
    editBrand(suffixUrl, item, item.id)    
  );
};

export const useDeleteQuery = (suffixUrl: string, key: string) => {

  const queryClient = useQueryClient()

  return useMutation((itemId) =>
    deleteBrand(suffixUrl, itemId),
    key != "" ?
      {
        // When mutate is called:
        onMutate: async newItem => {
          // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
          await queryClient.cancelQueries(key)

          // Snapshot the previous value
          const previousTodos = queryClient.getQueryData(key)

          // Optimistically update to the new value
          queryClient.setQueryData(key, (old: any) => [...old, newItem])

          // Return a context object with the snapshotted value
          return { previousTodos }
        },
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: (err, newItem, context: any) => {
          queryClient.setQueryData(key, context.previousTodos)
        },
        // Always refetch after error or success:
        onSettled: () => {
          queryClient.invalidateQueries(key)
        },
      } : {
        onMutate: async newItem => {

          return queryClient.invalidateQueries()

        },
        onSettled: () => {
          return queryClient.invalidateQueries()
        },
      }
  );
};

export const useDeleteWithItemQuery = (suffixUrl: string, key: string) => {

  const queryClient = useQueryClient()

  return useMutation((itemId) =>
    deleteBrandWithItem(suffixUrl, itemId),
    key != "" ?
      {
        // When mutate is called:
        onMutate: async newItem => {
          // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
          await queryClient.cancelQueries(key)

          // Snapshot the previous value
          const previousTodos = queryClient.getQueryData(key)

          // Optimistically update to the new value
          queryClient.setQueryData(key, (old: any) => [...old, newItem])

          // Return a context object with the snapshotted value
          return { previousTodos }
        },
        // If the mutation fails, use the context returned from onMutate to roll back
        onError: (err, newItem, context: any) => {
          queryClient.setQueryData(key, context.previousTodos)
        },
        // Always refetch after error or success:
        onSettled: () => {
          queryClient.invalidateQueries(key)
        },
      } : {
        onMutate: async newItem => {

          return queryClient.invalidateQueries()

        },
        onSettled: () => {
          return queryClient.invalidateQueries()
        },
      }
  );
};